import { CreateEventQ, DeleteConnectedEventsDTO, DeletedEventDetailsModel, EventDetailsToJoinEventDTO, EventR, EventsToCalendarDTO, EventsToTimeTableDTO, GetConnectedEventsToUpdateR, StudentEventListDTO, TeacherEventListDTO } from "../../../../shared/models/event/event.model";
import { GetUsersDataByEventIdR } from "../../user/user.model";

export const EVENT_FEATURE_KEY = 'EVENT';

export interface State{
    loaded:boolean;
    error?:string | null;
    data: EventR | EventR[]|DeletedEventDetailsModel[] |null|number|string[]|GetUsersDataByEventIdR[]|GetConnectedEventsToUpdateR|CreateEventQ[] | DeleteConnectedEventsDTO[] |EventDetailsToJoinEventDTO|TeacherEventListDTO|StudentEventListDTO|EventsToCalendarDTO[]|EventsToTimeTableDTO[];
}